import * as validate from "@repo/helpers/src/validators";
import { PostalCode } from "@repo/models";
import { useCallback } from "react";

import { useControllerApi } from "./tlpCloudApi";

export function useStatesApi() {
	const { Get } = useControllerApi("States");

	const getCityByZip = useCallback(
		async function (zipCode: string) {
			try {
				if (validate.zipCode(zipCode)) return null;
				return await Get<PostalCode>(`City/${zipCode}`);
			} catch {
				return null;
			}
		},
		[Get],
	);
	return { getCityByZip };
}
